import { Button, colors, TextField, Tooltip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/AddOutlined";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";

import {
  ConfigureDestinationsModal,
  KeyValueMappingControl,
} from "../../modals/ConfigureDestinationsModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { useModalStyles } from "../../modals/styles";

const WebhooksEndpointListConfigurationControl = ({
  field,
  value = [],
  onChange,
}) => {
  const classes = useModalStyles();

  const onWebhookChange = (index, newWebhook) => {
    const newValue = value.slice();
    newValue[index] = newWebhook;
    onChange(field.key, newValue);
  };

  const onDelete = (index) => {
    const newValue = value.slice();
    newValue.splice(index, 1);
    onChange(field.key, newValue);
  };

  return (
    <div className="justify-items-stretch" style={{ width: "100%" }}>
      {value.map((webhook, index) => {
        return (
          <div className="flex items-stretch" key={index}>
            <WebhookEndpointConfigurationControl
              field={field}
              webhook={webhook}
              onWebhookChange={(newWebhook) =>
                onWebhookChange(index, newWebhook)
              }
            />
            <span className="flex flex-wrap justify-end">
              <Tooltip title="Delete Webhook">
                <div
                  className="hover:bg-navy-200 p-1 rounded-full flex justify-center items-center"
                  onClick={() => onDelete(index)}
                >
                  <CloseIcon className={classes.closeIcon} />
                </div>
              </Tooltip>
            </span>
          </div>
        );
      })}
      <Button
        color="primary"
        className="text-xs bg-navy-100 text-navy-800 inline-block inline-flex items-center px-3 py-1 rounded cursor-pointer hover:bg-navy-200"
        onClick={() => onChange(field.key, [...value, { key: "", value: "" }])}
      >
        <AddIcon className="mr-1" style={{ width: 16 }} />
        Add Webhook
      </Button>
    </div>
  );
};

const WebhookEndpointConfigurationControl = ({
  field,
  webhook,
  onWebhookChange,
}) => {
  const classes = useModalStyles();

  const handleWebhookChange = (webhookChanges) => {
    const newWebhook = { ...webhook, ...webhookChanges };
    onWebhookChange(newWebhook);
  };

  return (
    <div className="justify-items-stretch" style={{ width: "100%" }}>
      <TextField
        fullWidth
        autoComplete="off"
        label={"Webhook URL"}
        name={"Webhook URL"}
        onChange={(event) =>
          handleWebhookChange({ endpoint: event.target.value })
        }
        value={webhook.endpoint || ""}
        key={field.name}
        variant="outlined"
        type={"text"}
        inputProps={{ style: { fontFamily: "monospace" } }}
        className={clsx(classes.inputField, "mb-2 fs-exclude")}
      />
      <KeyValueMappingControl
        field={field}
        value={webhook.headers || []}
        onChange={(fieldKey, newMapping) =>
          handleWebhookChange({ headers: newMapping })
        }
        keyLabel="Header name"
        valueLabel="Header value"
        objectLabel="Header"
      />
    </div>
  );
};

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
}) => {
  const allSettings = useSelector(
    (state) => state.destinations.data.webhooks.settings
  );

  return (
    <ConfigureDestinationsModal
      settingsToControl={{
        webhooks: WebhooksEndpointListConfigurationControl,
      }}
      limitSettings={["webhooks"]}
      open={open}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={handleUpdateConfigureDest}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen }) => {
  const allSettings = useSelector(
    (state) => state.destinations.data["webhooks"].settings
  );

  const webhooksSet =
    allSettings.webhooks &&
    allSettings.webhooks.length > 0 &&
    allSettings.webhooks[0].endpoint;

  return (
    <DestinationConfigRow
      name="Webhooks"
      labelColor={webhooksSet ? colors.green[600] : colors.red[600]}
      labelText={webhooksSet ? "Configured" : "Not Configured"}
      onOpenConfigModal={() => setConfigModalOpen("configuration")}
    />
  );
};

const OPTIONS = "OPTIONS";

const Rows = {
  OPTIONS: ConfigurationRow,
};

const Modals = {
  OPTIONS: ConfigurationModal,
};

const RowOrder = [OPTIONS];

export default {
  Rows,
  RowOrder,
  Modals,
};
